import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/dist/query/react'

export const ALLOWED_FILE_PREVIEW_EXTENSIONS = [
    'pdf',
    'docx',
    'doc',
    'pptx',
    'ppt',
    'xlsx',
    'xls',
    'jpg',
    'jpeg',
    'png',
    'html',
]
export type FileAuthPreviewFolder =
    | 'candidate_course'
    | 'candidate'
    | 'work'
    | 'work_trip'
    | 'ad_file'
    | 'tmp-apply-file'
    | 'ad-question-file'
export type FileAuthPreviewTempApplyFile = 'tmp-apply-file'
export type FileAuthRequestBody =
    | {
          fileId: number
          folder: FileAuthPreviewFolder
      }
    | {
          uid: string
          fileUid: string
          type: number
          folder: FileAuthPreviewTempApplyFile
      }

export type FileAuthResponseData = {
    fileId: number
    subscriptionId: number
    folder: FileAuthPreviewFolder
    name: string
    extension: string
    size: number
    scanStatus: number
    scannedStatus: number
    antivirusStatus: number
    created: string
    downloadUrl: string
    authUrl?: null | string
    extra: {
        courseId: number
        candidateId: number
    } | null
}

export type FileAuthResponse = {
    statusCode: number
    success: boolean
    message: string
    data: FileAuthResponseData
}

export type FileAuthValidationErrors = {
    fileId?: string[]
    folder?: string[]
}
export type FileAuthErrorResponse = {
    statusCode: number
    success: false
    message: string
    data: {
        errors: FileAuthValidationErrors
    }
}

export const filePreviewApi = createApi({
    reducerPath: 'filePreviewApi',
    baseQuery: fetchBaseQuery({
        baseUrl:
            process.env.ENV === 'local'
                ? `${process.env.API_URL}/api/file/preview`
                : `${window.location.origin}/api/file/preview`,
        prepareHeaders: (headers) => {
            const token = document.getElementsByName('csrf-token')[0]?.getAttribute('content')
            if (token) headers.set('X-CSRF-TOKEN', token)

            const customCorporation = document.getElementById('__custom_route_data')?.getAttribute('data-corpId')
            if (customCorporation) headers.set('X-CORP-CONTEXT', customCorporation)

            // headers.set('Response-V2', '1')
            return headers
        },
        credentials: process.env.ENV === 'local' ? 'include' : 'same-origin',
    }),
    tagTypes: ['filePreview'],
    endpoints: (builder) => ({
        fileAuth: builder.mutation<FileAuthResponseData, FileAuthRequestBody>({
            query: (body) => ({
                url: '/auth',
                method: 'POST',
                body,
            }),
            transformResponse: (response: FileAuthResponse) => response.data,
            invalidatesTags: ['filePreview'],
        }),
        postBinary: builder.mutation<Blob, FileAuthRequestBody>({
            query: (body) => ({
                url: '/binary',
                method: 'POST',
                body,
                responseHandler: async (response) => {
                    const buffer = await response.arrayBuffer()
                    // Конвертуємо в base64 рядок
                    const bytes = new Uint8Array(buffer)
                    let binary = ''
                    for (let i = 0; i < bytes.byteLength; i++) {
                        binary += String.fromCharCode(bytes[i])
                    }
                    return btoa(binary)
                },
                cache: 'no-cache',
                // body,
                // responseHandler: async (response: any): Promise<Blob> => {
                //     if (!response.ok) {
                //         throw new Error(response.statusText)
                //     }
                //     const contentType = response.headers.get('Content-Type')
                //     const arrayBuffer = await response.arrayBuffer()
                //     const blob = new Blob([arrayBuffer], { type: contentType })
                //     return blob
                // },
            }),
            // transformResponse: (response: FileAuthResponse) => response.data,
            invalidatesTags: ['filePreview'],
        }),
    }),
})

export const { useFileAuthMutation, usePostBinaryMutation } = filePreviewApi
